module.exports = __webpack_public_path__ + "static/media/outlook-icon.f1373017.svg";